module.exports = __webpack_public_path__ + "img/festival.a6dbfebf.png";